module.exports = __webpack_public_path__ + "img/Refresh.bd0012e5.svg";